import { render } from "./privacy.vue?vue&type=template&id=3dcd4e28&ts=true"
import script from "./privacy.vue?vue&type=script&lang=ts"
export * from "./privacy.vue?vue&type=script&lang=ts"

import "./privacy.vue?vue&type=style&index=0&id=3dcd4e28&lang=less"

import exportComponent from "/Users/coohua/shiNet/h5/privacyH5Source/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__